import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface TeamStatItemProps {
    isCompactView: boolean;
    shortLabel: string;
    value: string | number;
    type?: 'default' | 'positive' | 'warning' | 'error';
    onClick?: () => void;
    fullLabel?: string;
}

const getBarColorClass = (value: string | number) => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (numValue >= 70) return 'bar-excellent';
    if (numValue >= 55) return 'bar-good';
    if (numValue >= 40) return 'bar-average';
    return 'bar-poor';
};

export const TeamStatItem: React.FC<TeamStatItemProps> = ({
    isCompactView,
    shortLabel,
    value,
    type = 'default',
    onClick,
    fullLabel
}) => {
    // Only show progress bar for numeric values that can be percentages (0-100)
    const showBar = typeof value === 'number' && value >= 0 && value <= 100 && !isCompactView;
    const barWidth = showBar ? value : 0;

    return (
        <div
            className={`team-stat-item ${isCompactView ? 'team-stat-item-compact' : ''} team-stat-item-${type} ${onClick ? 'team-stat-item-clickable' : ''}`}
            onClick={onClick}
            style={{ cursor: onClick ? 'pointer' : 'default' }}
            title={fullLabel || shortLabel}
        >
            <div className={`team-stat-item-content ${isCompactView ? 'team-stat-item-content-compact' : ''}`}>
                <div className="team-stat-item-value">{value}</div>
                <div className="team-stat-item-label">{shortLabel}</div>
                {showBar && (
                    <div className="team-stat-bar-container">
                        <div className={`team-stat-bar ${getBarColorClass(value)}`} style={{ width: `${barWidth}%` }} />
                    </div>
                )}
            </div>
        </div>
    );
};
